var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("ul", { staticClass: "nav nav-tabs" }, [
          _c("li", { staticClass: "nav-item" }, [
            _c("a", { staticClass: "nav-link active", attrs: { href: "#" } }, [
              _vm._v("Active"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c("a", { staticClass: "nav-link", attrs: { href: "#" } }, [
              _vm._v("Link"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c("a", { staticClass: "nav-link", attrs: { href: "#" } }, [
              _vm._v("Link"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c("a", { staticClass: "nav-link disabled" }, [_vm._v("Disabled")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }